import React from "react";

import Link from "./Link";

type ExternalLinkProps = React.ComponentProps<typeof Link> & {
  openInNewTab?: boolean;
  trusted?: boolean;
};

function ExternalLink({
  className,
  openInNewTab = true,
  trusted = false,
  ...restProps
}: ExternalLinkProps) {
  return (
    <Link
      className={className}
      target={openInNewTab ? "_blank" : undefined}
      rel={trusted ? "noopener" : "noopener noreferrer"}
      {...restProps}
    />
  );
}

export default ExternalLink;
